export class PermissionError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'PermissionError';
  }
}
export class TierError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'TierError';
  }
}
